import useDocumentTitle from 'hooks/useDocumentTitle'
import InfographieEtapes1 from 'assets/default/png/infographie_etapes/infographie_etapes_1.png'
import InfographieEtapes2 from 'assets/default/png/infographie_etapes/infographie_etapes_2.png'
import InfographieEtapes3 from 'assets/default/png/infographie_etapes/infographie_etapes_3.png'
import InfographieEtapes4 from 'assets/default/png/infographie_etapes/infographie_etapes_4.png'
import Layout from 'layouts/Layout/Layout'
import TooltipBadge from 'components/TooltipBadge/TooltipBadge'
import { Accordion, Button, Container, Tab, Tabs } from 'react-bootstrap'
import ButtonIcon from 'components/ButtonIcon'
import Translation from 'assets/default/translation.json'
import Urls from 'assets/default/url.json'
import s from './BienUtiliser.module.scss'

const FAQ_CIBLER = [
  {
    title: "Qu'est-ce que « Cibler biens à vendre » ?",
    content: (
      <>
        <p>
          Une fonctionnalité puissante et innovante qui vous permet de{' '}
          <b>
            géolocaliser une maison ou un terrain à vendre sur votre zone de
            travail,
          </b>{' '}
          à partir des caractéristiques contenues dans une annonce immobilière.
        </p>
        <p>
          Comment est-ce possible ? Grâce à l&apos;intelligence de{' '}
          {Translation.common.produit} ! En analysant les données cadastrales et
          DVF (Données des Valeurs Foncières), la fonctionnalité « Cibler biens
          à vendre » vous restitue sur une carte les biens qui collent au plus
          près à vos critères de recherche.
        </p>
        <p>
          Vous l&apos;aurez compris, un outil si puissant requiert
          obligatoirement une formation adéquate pour être bien utilisé.
          Formez-vous donc dès maintenant :
        </p>
        <div className={s.helpButtons}>
          {typeof Urls.videos.decouvreOutil === 'string' && (
            <Button size="lg" href={Urls.videos.decouvreOutil} target="_blank">
              Je découvre l&apos;outil {Translation.common.produit}
            </Button>
          )}
          {typeof Urls.videos.geolocaliseUnBien === 'string' && (
            <Button
              size="lg"
              href={Urls.videos.geolocaliseUnBien}
              target="_blank"
            >
              Je géolocalise un bien grâce à {Translation.common.produit}
            </Button>
          )}
          {typeof Urls.pagesOmega.formation === 'string' && (
            <Button size="lg" href={Urls.pagesOmega.formation} target="_blank">
              M’inscrire au webinar
            </Button>
          )}
        </div>
      </>
    ),
  },
  {
    title: "Quand l'utiliser ?",
    content: (
      <>
        <p>
          <b>
            Prolongez votre pige et veille concurrentielle quotidiennes sur
            Yanport
          </b>{' '}
          par une session {Translation.common.produit}. Un propriétaire ne
          répond pas au téléphone ou décline votre proposition de RDV ? Mettez
          de côté l&apos;annonce en question. Une fois votre pige terminée,
          ouvrez {Translation.common.produit} et tentez de localiser un à un les
          biens mis de côté.
        </p>
        <p>
          <b>Le résumé en 4 étapes :</b>
        </p>
        <ol className={s.infographieEtapes}>
          <li>
            <span>
              Je fais <b>ma pige</b> &amp;
              <br />
              ma{' '}
              <b>
                veille
                <br />
                concurrentielle
              </b>
            </span>
            <img src={InfographieEtapes1} alt="Etape 1: Je fais ma pige" />
          </li>
          <li>
            <span>
              Je{' '}
              <b>
                saisis les
                <br />
                caractéristiques
              </b>
              <br />
              de mon annonce
            </span>
            <img
              src={InfographieEtapes2}
              alt="Etape 2: Je saisis les caractéristiques de mon annonce"
            />
          </li>
          <li>
            <span>
              Je <b>géolocalise</b> le
              <br />
              bien
            </span>
            <img
              src={InfographieEtapes3}
              alt="Etape 3: Je géolocalise le bien"
            />
          </li>
          <li>
            <span>
              Je vais{' '}
              <b>
                sonner à
                <br />
                la porte
              </b>
            </span>
            <img
              src={InfographieEtapes4}
              alt="Etape 4: Je vais sonner à la porte"
            />
          </li>
        </ol>
      </>
    ),
  },
  {
    title: "Sur quelles annonces l'utiliser ?",
    content: (
      <>
        <p>
          <b>
            Les annonces de maisons individuelles (hors lotissements &
            copropriétés) et de terrains. Pas les appartements.
          </b>
        </p>
        <p>
          Pourquoi ? Parce que {Translation.common.produit} va rechercher dans
          le cadastre et DVF et a donc besoin de{' '}
          <b>l&apos;emprise au sol et la surface de la parcelle cadastrale.</b>
        </p>
        <p>
          De votre côté, vous n&apos;avez qu&apos;à saisir les caractéristiques
          contenues dans l&apos;annonce (surface habitable, nombre de niveaux,
          etc.). {Translation.common.produit} affichera alors la liste des
          résultats correspondants. Ce sera ensuite à vous de jouer en repérant
          les détails notoires du bien (emplacement des arbres, disposition des
          fenêtres, ...) pour finaliser la sélection.
          <br />
          Vous pensez avoir trouvé le bien ? Ajoutez-le vite à vos favoris pour
          aller le voir sur le terrain !
        </p>
      </>
    ),
  },
  {
    title: 'A quoi sert « Voir résultats en favoris » ?',
    content: (
      <>
        <p>
          Lorsque vous recherchez un bien, ajoutez-le à vos favoris en cliquant
          sur le cœur (
          <ButtonIcon className={s.heart} icon="heart" />) situé en haut à
          droite de la fiche.
          <br />
          Une fois votre session terminée, rendez-vous dans la rubrique « Voir
          résultats en favoris » : exportez la liste de biens favoris, puis
          imprimez-la ou envoyez-vous la par mail. Grâce aux liens GPS présents
          sur la liste, Google Maps ou Waze vous indiquera le chemin le plus
          court pour aller prospecter ces biens.
        </p>
        <p>
          Maintenant, à vous de jouer : enfilez vite vos chaussures et allez
          sonner aux portes !
        </p>
      </>
    ),
  },
  {
    title: "Sur quelle zone géographique l'utiliser ?",
    content: (
      <p>
        <b>Sur vos codes postaux de pige Yanport.</b>
      </p>
    ),
  },
  {
    title: "Comment obtenir de l'aide ?",
    content: (
      <>
        <p>
          Pour des raisons évidentes, la Hotline ne peut pas vous aider à faire
          vos recherches sur {Translation.common.produit}. Rassurez-vous ! Vous
          avez <b>de nombreux autres outils</b> à disposition pour vous aider :
        </p>
        <ol>
          <li>
            <span>
              <b>Formez-vous</b> dès maintenant :
            </span>
            <br />
            <br />
            <div className={s.helpButtons}>
              {typeof Urls.videos.decouvreOutil === 'string' && (
                <Button
                  size="lg"
                  href={Urls.videos.decouvreOutil}
                  target="_blank"
                >
                  Je découvre l&apos;outil {Translation.common.produit}
                </Button>
              )}
              {typeof Urls.videos.geolocaliseUnBien === 'string' && (
                <Button
                  size="lg"
                  href={Urls.videos.geolocaliseUnBien}
                  target="_blank"
                >
                  Je géolocalise un bien grâce à {Translation.common.produit}
                </Button>
              )}
              {typeof Urls.pagesOmega.formation === 'string' && (
                <Button href={Urls.pagesOmega.formation} target="_blank">
                  M’inscrire au webinar
                </Button>
              )}
            </div>
            <br />
          </li>
          <li>
            <p>
              <b>Consultez les nombreux espaces d&apos;information</b> (marqués
              par un&nbsp;
              <TooltipBadge label="" />) présents tout au long de votre
              navigation.
            </p>
          </li>
        </ol>
      </>
    ),
  },
  {
    title: 'Vous ne parvenez pas à géolocaliser le bien que vous cherchez ?',
    content: (
      <>
        <p>
          <b>Augmentez l&apos;emprise au sol et/ou la surface du terrain :</b>{' '}
          vous obtiendrez ainsi plus de résultats et ferez le tri en fonction de
          l&apos;aspect de chaque bien.
        </p>
        <p>
          <b>Faites des essais !</b> C&apos;est par la pratique qu&apos;on
          devient expert 🙂
        </p>
        <p className={s.stillNotFound}>
          <b>
            Vous n&apos;avez toujours pas trouvé ? Ça arrive, c&apos;est normal
            !
          </b>{' '}
          Certains biens sont difficiles à géolocaliser, pour diverses raisons :
        </p>
        <ul>
          <li>
            Les critères saisis ne concordent pas avec les données du cadastre
            et de DVF : terrain composé de plusieurs parcelles, extension ou
            piscine non déclarée, ...
          </li>
          <li>
            Les informations disponibles ne sont pas suffisantes pour vous
            permettre de faire une recherche pertinente
          </li>
        </ul>
        <p>
          {Translation.common.produit} est comme Meetic : on n&apos;a pas la
          garantie de dénicher la pépite ! Retentez avec une autre annonce 😉
          <br />
          Et souvenez-vous : la valeur sûre pour trouver des mandats reste le
          terrain !
        </p>
      </>
    ),
  },
]

const FAQ_ETUDIER = [
  {
    title: "Qu'est ce que « Etudier votre marché » ?",
    content: (
      <>
        <p>
          Cette fonctionnalité est{' '}
          <b>
            idéale pour étudier votre marché au moment du démarrage de votre
            activité
          </b>{' '}
          : elle vous permet de{' '}
          <b>visualiser sur une carte les biens vendus dans votre quartier !</b>{' '}
          Vous pouvez affiner vos recherches par année et filtrer selon
          différents critères (type de bien, surface habitable,…) pour
          comprendre les dynamiques locales passées.
        </p>
        <p>
          Pour faire vos estimations, l&apos;outil phare reste Yanport qui
          propose un dossier d&apos;estimation complet.
          <br />
          Vous pourrez évidemment revenir à tout moment sur cette fonctionnalité
          de {Translation.common.produit} si vous avez besoin d&apos;affiner vos
          connaissances sur bien particulier ou un quartier donné.
        </p>
      </>
    ),
  },
  {
    title: "Sur quelle zone géographique l'utiliser ?",
    content: (
      <p>
        <b>Sur vos codes postaux de pige Yanport.</b>
      </p>
    ),
  },
  {
    title: "Qui peut l'utiliser ?",
    content: (
      <p>
        Parce que cette fonctionnalité est idéale pour bien démarrer son
        activité,{' '}
        <b>
          tous les {Translation.common.mandataire}s y ont accès dès leur entrée
          chez {Translation.common.societe}.
        </b>
      </p>
    ),
  },
  {
    title: "Comment obtenir de l'aide ?",
    content: (
      <>
        <p>
          <b>Formez-vous</b> dès maintenant à étudier votre marché efficacement
          :
        </p>
        <div className={s.helpButtons}>
          {typeof Urls.pagesOmega.formation === 'string' && (
            <Button href={Urls.pagesOmega.formation} target="_blank" size="lg">
              M’inscrire au webinar
            </Button>
          )}
          {typeof Urls.pagesOmega.elearningOutils === 'string' && (
            <Button
              href={Urls.pagesOmega.elearningOutils}
              target="_blank"
              size="lg"
            >
              Voir les tutoriels e-learning
            </Button>
          )}
        </div>
        <br />
        <p>
          Par ailleurs, n&apos;hésitez pas à{' '}
          <b>en parler à votre coach-formateur !</b>
        </p>
      </>
    ),
  },
  {
    title: "Vous n'avez pas beaucoup de résultats ?",
    content: (
      <>
        <p>
          Cette fonctionnalité de {Translation.common.produit} restitue les
          données disponibles dans DVF (Données des Valeurs Foncières). Elle est
          donc tributaire des mises à jour de DVF. Réessayez en élargissant les
          dates de transaction.
        </p>
        <p>
          A noter que les données DVF ne sont pas disponibles pour l&apos;Alsace
          Moselle.
        </p>
      </>
    ),
  },
]

const BienUtiliser = (): JSX.Element => {
  useDocumentTitle('Bien utiliser')

  return (
    <Layout className={s.bienUtiliser}>
      <Container>
        <h2 className={s.title}>Bien utiliser {Translation.common.produit}</h2>
        <p>
          Bienvenue sur {Translation.common.produit}, un outil{' '}
          {Translation.common.societe} puissant et innovant qui peut booster
          votre prospection !
        </p>
        <p className={s.functionality}>
          Il est constitué de deux fonctionnalités :
        </p>
        <ul>
          <li>Etudier votre marché</li>
          <li>Cibler biens à vendre</li>
        </ul>
        <p>Pour bien les utiliser, parcourez vite les onglets ci-dessous.</p>
        <Tabs
          className={s.tabs}
          defaultActiveKey="cibler"
          id="etudier-ou-cibler"
        >
          <Tab eventKey="cibler" title="Cibler biens à vendre">
            <p>
              Vous voulez booster votre prospection physique ? Accélérer la
              rentrée de mandats ?
            </p>
            <p>
              <b>
                La fonctionnalité « Cibler biens à vendre » de{' '}
                {Translation.common.produit} peut vous y aider !
              </b>
            </p>
            <p>
              <b>
                Décuplez l&apos;efficacité de votre pige et de votre veille
                concurrentielle en géolocalisant les biens à vendre (en PAP ou
                par la concurrence)
              </b>{' '}
              sur votre zone de travail grâce aux critères contenus dans les
              annonces Yanport. Enfilez vos baskets, c&apos;est parti : sonnez à
              la porte et décrochez le mandat !
            </p>
            <Accordion defaultActiveKey="1" className={s.accordion}>
              {FAQ_CIBLER.map(({ title, content }, idx) => (
                <Accordion.Item
                  key={`faq-cibler-${idx}`}
                  eventKey={idx.toString()}
                >
                  <Accordion.Header>{title}</Accordion.Header>
                  <Accordion.Body>{content}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Tab>
          <Tab eventKey="etudier" title="Etudier votre marché">
            <p>
              Etudiez votre marché efficacement en visualisant sur une carte les
              biens (maisons, appartements et terrains) vendus dans votre
              quartier !
            </p>
            <Accordion defaultActiveKey="0" className={s.accordion}>
              {FAQ_ETUDIER.map(({ title, content }, idx) => (
                <Accordion.Item
                  key={`faq-etudier-${idx}`}
                  eventKey={idx.toString()}
                >
                  <Accordion.Header>{title}</Accordion.Header>
                  <Accordion.Body>{content}</Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Tab>
        </Tabs>
      </Container>
    </Layout>
  )
}

export default BienUtiliser
